import { cn } from '@forest/shared'

// A placeholder bar's look, shared by every skeleton in the Shop: the card,
// hero and balance placeholders and the boot skeleton (GLOSSARY.md "Boot
// skeleton"). The design's placeholder ink at 40% opacity, flat. The caller
// adds its size.
export const PLACEHOLDER_BAR_CLASS = 'rounded-full bg-ink/[0.12]'

/**
 * A placeholder bar standing in for one line of text: an inline bar inside a
 * paragraph of the real text's type classes, so the line takes the real
 * text's height. `class` sizes the bar.
 */
export function PlaceholderTextLine(props: {
  class: string
  typeClass: string
}) {
  return (
    <p class={props.typeClass}>
      <span
        class={cn(
          'inline-block align-middle',
          PLACEHOLDER_BAR_CLASS,
          props.class,
        )}
      />
    </p>
  )
}
